import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { Page } from 'theme/Page';

import {
  Section
} from 'components/PublicPages/GlobalPublicStyles';

const {
  media_md,
  public_font_size,
  public_font_size_md,
} = variables;

export const ContactPage = styled(Page)`
  
`;


export const ContactSection = styled(Section)`  
  padding: 40px 0 !important;
  @media ${media_md} {
    padding: 50px 0 !important;
  }
`;



export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`

export const ContactUsFormWrapper = styled.div` 
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 90px;
  h4 {
    font-size: 20px;
  }
  .message {
    margin-bottom: 52px;
  }

  @media ${media_md} {
    margin-bottom: 0;
    .form-title {
      padding: 50px 0 0px;
    }
    h4 {
      font-size: ${public_font_size};
      line-height: 24px;
      margin: 0;
    }
  }
`

export const ContactWrapper = styled.div`
  position: relative;
  max-width: 290px;
  padding-left: 20px;
  a {
    color: #414141 !important;
    &:visited {
      color: #414141;
    }
  }

  h5{
    max-width: 290px;	
    color: #414141;
    font-size: 18px;
    font-weight: bold;	
    line-height: 18px;
  }

  p{
    max-width: 290px;	
    color: #414141;	
    font-size: ${public_font_size_md};	
    letter-spacing: 0.5px;	
    line-height: 21px;
  }
`


